module.exports = __webpack_public_path__ + "img/義務勞動.56bb1d4a.jpg";